import React, {useContext, useRef, useState} from "react";
import {useLocation, useParams} from "react-router-dom";
import {useHistory} from "react-router-dom";
import GenericTemplate from "../../../templates/GenericTemplate";
import {
  APOLLO_SYSTEM_ADMIN,
  APOLLO_GROUP_OPERATOR,
  ApolloPageUsagePermission
} from "../../../atom/Apollo_Authorization";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../../atom/Apollo_Breadcrumbs2";
import {ApolloMessage, CustomizedSnackbars} from "../../../atom/Apollo_Mesasge";
import {
  AdGroupNew,
  AdGroupZeus,
  DemographicRelation,
  LogRecord,
  OsType,
} from "./AdGroupModelZeus";
import AdGroupFormZeus from "./AdGroupFormZeus";
import {ApiResponse, ApolloAxios, getResultType} from "../../../atom/Apollo_ApiRequest3";
import {
  adgroups_path,
  get_zeus_ad_group_path
} from "../../../atom/Apollo_links";
import {
  ApolloEventRecord,
  createLogDate, createUserLogItemListByOption,
  createUserLogItemListFromArrayAddSB,
  createUserLogItemListFromNumber,
  createUserLogItemListFromString,
  ItemList, LogData
} from "../../../atom/Apollo_EventRecord";
import {useForm} from "react-hook-form";
import {ApolloContext} from "../../../atom/Apollo_Context";
import {
  OS_TYPE_ZEUS_NUMBER,
  Option,
  ZEUS_DELIVERY_TYPE,
  options_ostype_zeus_number,
  options_state_edit,
  options_zeus_campaign_type,
  valueToOptionNull,
} from "../../../atom/Apollo_styles";
import moment from "moment";
import {BLANK} from "../../ACCOUNT/sh/common/CommonConst";
import {formatLogFromDemographics} from "../../../common/PLATFORM/zeus/FunctionZeus";
import {
  AFFINITY_CATEGORY_MAX_ZEUS,
  RETARGETING_MAX_ZEUS,
  TARGET_TYPE,
  options_zeus_ad_target,
} from "./common/CommonConst";
import {getTrackerAudience} from "../../../common/Apollo_CommonUtil";
import {ApolloDialog} from "../../../atom/Apollo_Dialog";
import {ApolloConfirmNotActiveDialog} from "../../../organism/HERA/ConfirmNotActiveDialog";

// 画面名：広告グループ作成（SH）
const AdGroupCreateZeus = () => {
  const history = useHistory();
  const {state} = useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const {accountgroupid, accountid, platformaccountid} = useParams<{
    accountgroupid: string,
    accountid: string,
    platformaccountid: string,
  }>();
  const reqParams = new URLSearchParams(useLocation().search);
  const campaignId = reqParams.get("campaignId") ?? "0";
  const queryCampaignId = campaignId !== "0" ? `?campaignId=${campaignId}` : "";
  const adGroupData = useRef<AdGroupZeus | null>(null);
  const beforeEditRecord = useRef<LogRecord | null>(null);
  let [ageMin, setAgeMin] = useState<number | null>(null);
  let [ageMax, setAgeMax] = useState<number | null>(null);
  const [gender1, setGender1] = useState(false);
  const [gender2, setGender2] = useState(false);
  const [gender3, setGender3] = useState(false);
  const [prefRenderId, setPrefRenderId] = useState(0);
  const [osType, setOsType] = useState<OsType>({
    pc: true,
    ios: true,
    android: true,
  });
  const [cpcLimitOver, setCpcLimitOver] = useState(true);
  const [isCpcLimitDisabled, setIsCpcLimitDisabled] = useState<boolean>(false);
  const [checkedPref, setCheckedPref] = useState([false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, ]);
  const processing = useRef(false);
  const optionAudiences2 = useRef<Option[]>([]);
  const optionAffinityCategories2 = useRef<Option[]>([]);
  const optionCustomSegments2 = useRef<Option[]>([]);
  const isExistsNotActiveAudience = useRef<boolean>(false)
  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false)

  const {register, control, errors, setError, formState} = useForm();


  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 24,
    breadId: 2,
    queries: ["", "", "", "", queryCampaignId],
    menu: {
      id: 1,
      accountId: platformaccountid,
      accountName: "",
    },
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }
  const [adGroup, setAdGroup] = useState<AdGroupZeus>({
    id: 0,
    createdAt: "",
    updatedAt: "",
    lastUpdateUserId: 0,
    adAccountId: Number(platformaccountid),
    adCampaignId: Number(campaignId),
    adCampaignName: "",
    deliveryType: 1,
    name: "",
    cpcLimit: 1,
    cpcLimitOver: true,
    billingType: 1,
    status: 2,
    targetingType: 4,
    customSegmentId: 0,
    affinityCategoryIds: [],
    retargetingIds: [],
    demographicRelations: [],
    osTargetings: [],
    audienceRelations: [],
    segmentRelations: [],
    cpmLimit: 1,
    pmpType: null,
    placementSettingId: null,
  });

  const handleOpenConfirm = () => {
    if (!openConfirmDialog) setOpenConfirmDialog(true)
  }

  const handleCloseConfirm = () => {
    if (openConfirmDialog) setOpenConfirmDialog(false)
  }

  const handleSubmit = async (
    optionAudiences: Option[],
    optionAffinityCategories: Option[],
    optionCustomSegments: Option[],
  ) => {
    if (!osType.pc && !osType.ios && !osType.android) {
      console.log('配信OSを選択してください。');
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "配信OSを選択してください。"
        }
      });
      return;
    }

    // アフィニティカテゴリバリデーション
    if (adGroup.targetingType === TARGET_TYPE.AFFINITY) {
      if (adGroup.affinityCategoryIds.length === 0) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: "アフィニティカテゴリを1つ以上選択してください。",
          }
        });
        return;
      }

      if (adGroup.affinityCategoryIds.length > AFFINITY_CATEGORY_MAX_ZEUS) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: `アフィニティカテゴリは最大${AFFINITY_CATEGORY_MAX_ZEUS}個まで設定可能です。`,
          }
        });
        return;
      }
    }

    // カスタムセグメントバリデーション
    if (adGroup.targetingType === TARGET_TYPE.SEGMENT) {
      if (adGroup.customSegmentId === 0) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: "カスタムセグメントを選択してください。",
          }
        });
        return;
      }
    }

    // 配信オーディエンス設定バリデーション
    if (adGroup.targetingType === TARGET_TYPE.RETARGET) {
      if (adGroup.retargetingIds.length === 0) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: "配信オーディエンス設定を1つ以上選択してください。",
          }
        });
        return;
      }

      if (adGroup.retargetingIds.length > RETARGETING_MAX_ZEUS) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: `配信オーディエンス設定は最大${RETARGETING_MAX_ZEUS}個まで設定可能です。`,
          }
        });
        return;
      }
    }

    // 年齢バリデーション
    if (ageMin && ageMax) {
      if (ageMin > ageMax) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: "最小年齢が最大年齢より大きく指定されています",
          }
        });
        return;
      }
    }
    if (ageMin && !ageMax){
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "最大年齢を指定するか、最小年齢をクリアしてください",
        }
      });
      return;
    }
    if (!ageMin && ageMax){
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "最小年齢を指定するか、最大年齢をクリアしてください",
        }
      });
      return;
    }

    isExistsNotActiveAudience.current = false;

    optionAudiences2.current = optionAudiences
    optionAffinityCategories2.current = optionAffinityCategories
    optionCustomSegments2.current = optionCustomSegments

    if (adGroup.targetingType === TARGET_TYPE.RETARGET) {
      if (state.current.trackerId) {
        const localValAudience = await getTrackerAudience(state.current.trackerId);
        if (localValAudience.message !== "") {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: localValAudience.message
            }
          });
          return
        }
        if (localValAudience.result) {
          for (const id of adGroup.retargetingIds) {
            const val = localValAudience?.result?.find(v => v.ID === id)
            if (val?.isActive === false) {
              isExistsNotActiveAudience.current = true;
              break;
            }
          }
        }
      }

      if (isExistsNotActiveAudience.current) {
        handleOpenConfirm()
        return;
      }
    }

    await handleSubmitExecute();
  };

  const handleSubmitExecute = async () => {
    console.log('handleSubmit');
    console.log(processing.current);

    let isSuccess = false;
    const osTypeNames: string[] = []
    const retargetingNames: string[] = [];
    const affinityCategoryNames: string[] = [];
    let customSegmentName: string = "";

    beforeEditRecord.current = {
      adAccountId: Number(platformaccountid),
      adCampaignId: null,
      adCampaignName: "",
      deliveryType: null,
      name: "",
      cpcLimit: null,
      cpcLimitOver: false,
      status: null,
      demographicAgeRanges: [],
      demographicGenders: [],
      demographicAddress: [],
      osTypes: [],
      osTypeNames: [],
      targetingType: -1,
      customSegmentId: 0,
      customSegmentName: "",
      affinityCategoryIds: [],
      affinityCategoryNames: [],
      retargetingIds: [],
      retargetingNames: [],
      cpmLimit: null,
      pmpType: 1,
      placementSettingId: null,
    }

    const apiBody: AdGroupNew = {
      adAccountId: Number(platformaccountid),
      adCampaignId: adGroup.adCampaignId,
      name: adGroup.name,
      cpcLimit: adGroup.deliveryType === ZEUS_DELIVERY_TYPE.DSP || isCpcLimitDisabled ? null : Number(adGroup.cpcLimit),
      cpcLimitOver: cpcLimitOver,
      status: adGroup.status,
      targetingType: adGroup.targetingType,
      customSegmentId: adGroup.targetingType === TARGET_TYPE.SEGMENT ? adGroup.customSegmentId : null,
      affinityCategoryIds: adGroup.targetingType === TARGET_TYPE.AFFINITY ? adGroup.affinityCategoryIds : null,
      retargetingIds: adGroup.targetingType === TARGET_TYPE.RETARGET ? adGroup.retargetingIds : null,
      osTargetings: [],
      demographicRelations: [],
      audienceRelations: [],
      segmentRelations: [],
      cpmLimit: adGroup.deliveryType === ZEUS_DELIVERY_TYPE.PERFORMANCE ? null : Number(adGroup.cpmLimit),
      placementSettingId: adGroup.placementSettingId
    }

    if (osType.pc) {
      apiBody.osTargetings.push({
        osType: OS_TYPE_ZEUS_NUMBER.PC,
        versionMin: null,
        versionMax: null,
      })
      const option = valueToOptionNull(OS_TYPE_ZEUS_NUMBER.PC, options_ostype_zeus_number);
      if(option) {
        osTypeNames.push(option.label)
      }
    }
    if (osType.ios) {
      apiBody.osTargetings.push({
        osType: OS_TYPE_ZEUS_NUMBER.IOS,
        versionMin: null,
        versionMax: null,
      })
      const option = valueToOptionNull(OS_TYPE_ZEUS_NUMBER.IOS, options_ostype_zeus_number);
      if(option) {
        osTypeNames.push(option.label)
      }
    }
    if (osType.android) {
      apiBody.osTargetings.push({
        osType: OS_TYPE_ZEUS_NUMBER.ANDROID,
        versionMin: null,
        versionMax: null,
      })
      const option = valueToOptionNull(OS_TYPE_ZEUS_NUMBER.ANDROID, options_ostype_zeus_number);
      if(option) {
        osTypeNames.push(option.label)
      }
    }

    if (adGroup.targetingType === TARGET_TYPE.AFFINITY) {
      adGroup.affinityCategoryIds?.map((id: number) => {
        const option = valueToOptionNull(id, optionAffinityCategories2.current);
        if(option) {
          affinityCategoryNames.push(option.label);
        }
      })
    }

    if (adGroup.targetingType === TARGET_TYPE.SEGMENT) {
      const customSegmentId: number = adGroup.customSegmentId
      const option = valueToOptionNull(customSegmentId, optionCustomSegments2.current);
      if(option) {
        customSegmentName = option.label;
      }
    }

    if (adGroup.targetingType === TARGET_TYPE.RETARGET) {
      adGroup.retargetingIds?.map((id: number) => {
        const option = valueToOptionNull(id, optionAudiences2.current);
        if(option) {
          retargetingNames.push(option.label);
        }
      });
    }

    //デモグラ更新
    // 性別
    const genderList: number[] = [];
    if (gender1) {genderList.push(1)};
    if (gender2) {genderList.push(2)};
    if (gender3) {genderList.push(3)};
    let genderString: string | null = ""
    if (genderList.length > 0) {
      genderString = genderList.join(",")
    } else {
      genderString = null
    }

    // 居住地
    const prefList: number[] = [];
    for (let i = 0; i < checkedPref.length; i++ ) {
      if (checkedPref[i]) {
        prefList.push(i + 1)
      }
    }
    let prefString: string | null = ""
    if (prefList.length > 0) {
      prefString = prefList.join(",")
    } else {
      prefString = null
    }

    const demographicRelation: DemographicRelation = {
      ageMin: adGroup.targetingType == TARGET_TYPE.NONTARGET? null: ageMin?? null,
      ageMax: adGroup.targetingType == TARGET_TYPE.NONTARGET? null: ageMax?? null,
      genderCodeList: adGroup.targetingType == TARGET_TYPE.NONTARGET? null: genderString,
      prefCodeList: adGroup.targetingType == TARGET_TYPE.NONTARGET? null: prefString,
    }
    apiBody.demographicRelations = ([demographicRelation])
    
    const demographicLog = formatLogFromDemographics(apiBody.demographicRelations);
    const executeLog = createUserLog(
      state,
      "パフォーマンス広告",
      "広告グループ",
      "作成",
      "広告グループ（パフォーマンス広告）作成",
      beforeEditRecord.current,
      {
        adAccountId: Number(platformaccountid),
        adCampaignId: adGroup.adCampaignId,
        adCampaignName: adGroup.adCampaignName,
        deliveryType: adGroup.deliveryType,
        name: adGroup.name,
        cpcLimit: adGroup.deliveryType === ZEUS_DELIVERY_TYPE.DSP || isCpcLimitDisabled ? null : adGroup.cpcLimit,
        cpcLimitOver: adGroup.cpcLimitOver,
        status: adGroup.status,
        demographicAgeRanges: demographicLog.ageRanges,
        demographicGenders: demographicLog.genders,
        demographicAddress: demographicLog.address,
        osTypes: adGroup.osTargetings.map((osTargeting:any) => {return osTargeting.osType}),
        osTypeNames: osTypeNames,
        targetingType: adGroup.targetingType,
        customSegmentId: adGroup.targetingType === TARGET_TYPE.SEGMENT ? adGroup.customSegmentId : 0,
        customSegmentName: adGroup.targetingType === TARGET_TYPE.SEGMENT ? customSegmentName : "",
        affinityCategoryIds: adGroup.targetingType === TARGET_TYPE.AFFINITY ? adGroup.affinityCategoryIds : [],
        affinityCategoryNames: adGroup.targetingType === TARGET_TYPE.AFFINITY ? affinityCategoryNames : [],
        retargetingIds: adGroup.targetingType === TARGET_TYPE.RETARGET ? adGroup.retargetingIds : [],
        retargetingNames: adGroup.targetingType === TARGET_TYPE.RETARGET ? retargetingNames : [],
        cpmLimit: adGroup.deliveryType === ZEUS_DELIVERY_TYPE.PERFORMANCE ? null : adGroup.cpmLimit,
        pmpType: adGroup.pmpType,
        placementSettingId: adGroup.placementSettingId,
      },
      adGroup.adCampaignId.toString(), // キャンペーンID
      adGroup.adCampaignName, // キャンペーン名
      BLANK, // 広告グループID
      BLANK, // 広告グループ名
    );

    ApolloEventRecord({...executeLog, logType: "execute"});
    const url = process.env.REACT_APP_API_ENDPOINT + get_zeus_ad_group_path;
    // console.log('executeLog');
    // console.log(executeLog);
    // console.log('apiBody');
    // console.log(apiBody);
    let registedId = BLANK;
    ApolloAxios.post(url, apiBody).then(response => {
      const res: ApiResponse = response.data;
      if (response.status !== 201) {
        return Promise.reject({
          open: true,
          type: getResultType(response.status === 400 ? -1 : -9),
          errmsg: "広告グループの作成に失敗しました",
        });
      } else {
        registedId = response.data.id?.toString() ?? BLANK;
      }

      // if (!isSuccessApi(res.resultCode)) {
      //   return Promise.reject({
      //     open: true,
      //     type: getResultType(res.resultCode),
      //     errmsg: res?.message ? res.message : "広告グループの作成に失敗しました",
      //   });
      // }

      isSuccess = true;
      adGroupData.current = adGroup;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "success",
          message: "広告グループの作成に成功しました"
        }
      });

    }).catch(err => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    }).finally(() => {
      const resultLog: LogData = {
        ...executeLog,
        eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        targetID: registedId,
        targetName: adGroupData.current? adGroupData.current?.name: "",
        result: isSuccess ? "成功" : "失敗",
        adGroupName: adGroupData.current? adGroupData.current?.name: "",
        adGroupID: registedId,
      };
      ApolloEventRecord({...resultLog, logType: "result"});

      if(isSuccess) {
        window.scrollTo(0, 0);
        const query = campaignId === "0" ? "" : `?campaignId=${adGroup.adCampaignId}`;
        history.push(`${adgroups_path}zeus/${accountgroupid}/${accountid}/${platformaccountid}${query}`);
      }
    });
  };

  const handleGoBack = () => {
    // キャンセルボタンクリック時のアクション
    const query = campaignId === "0" ? "" : `?campaignId=${campaignId}`;
    history.push(`${adgroups_path}zeus/${accountgroupid}/${accountid}/${platformaccountid}${query}`);
  }

  return (
    <GenericTemplate title="">
      <CustomizedSnackbars/>
      <ApolloPageUsagePermission role={APOLLO_GROUP_OPERATOR} profile={APOLLO_SYSTEM_ADMIN}>
        <ApolloBreadcrumbs2 data={breadcrumbsData}/>
        <AdGroupFormZeus
          platformAccountId={Number(platformaccountid)}
          adGroupId={0}
          adGroupState={{
            adGroup: adGroup,
            setAdGroup: setAdGroup,
            osType: osType,
            setOsType: setOsType,
            cpcLimitOver: cpcLimitOver,
            setCpcLimitOver: setCpcLimitOver,
            isCpcLimitDisabled: isCpcLimitDisabled,
            setIsCpcLimitDisabled: setIsCpcLimitDisabled,
            errors: errors,
            setError: setError
          }}
          demograStatus={{
            ageMin: ageMin,
            setAgeMin: setAgeMin,
            ageMax: ageMax,
            setAgeMax: setAgeMax,
            gender1: gender1,
            setGender1: setGender1,
            gender2: gender2,
            setGender2: setGender2,
            gender3: gender3,
            setGender3: setGender3,
            checkedPref: checkedPref,
            setCheckedPref: setCheckedPref,
            prefRenderId: prefRenderId,
            setPrefRenderId: setPrefRenderId
          }}
          hasAd={false}
          submitAction={handleSubmit}
          goBackAction={handleGoBack}
        />
      </ApolloPageUsagePermission>
      <ApolloDialog open={openConfirmDialog} setOpen={setOpenConfirmDialog}>
        <ApolloConfirmNotActiveDialog
          isExistsNotActiveAudience={isExistsNotActiveAudience.current}
          handleSave={handleSubmitExecute}
          handleClose={handleCloseConfirm}
        />
      </ApolloDialog>
    </GenericTemplate>
  )
};

const createUserLog = (
  apolloContex: any,
  menu: string,
  category: string,
  actionType: string,
  displayName: string,
  beforeInfo: LogRecord | null,
  afterInfo: LogRecord,
  campaignId?: string,
  campaignName?: string,
  adGroupId?: string,
  adGroupName?: string,
) => {
  const items: ItemList[] = [
    createUserLogItemListFromNumber("プラットフォームアカウントID", "adAccountId", beforeInfo, afterInfo),
    createUserLogItemListByOption("キャンペーン種別", "deliveryType", beforeInfo, afterInfo, options_zeus_campaign_type),
    createUserLogItemListByOption("ステータス", "status", beforeInfo, afterInfo, options_state_edit),
    createUserLogItemListFromNumber("目標CPC", "cpcLimit", beforeInfo, afterInfo),
    createUserLogItemListFromNumber("上限CPM", "cpmLimit", beforeInfo, afterInfo),
    createUserLogItemListFromNumber("入札制御", "cpcLimitOver", beforeInfo, afterInfo),
    createUserLogItemListFromArrayAddSB("デモグラ情報_性別", "demographicGenders", beforeInfo, afterInfo),
    createUserLogItemListFromArrayAddSB("デモグラ情報_年齢", "demographicAgeRanges", beforeInfo, afterInfo),
    createUserLogItemListFromArrayAddSB("デモグラ情報_居住地", "demographicAddress", beforeInfo, afterInfo),
    createUserLogItemListFromArrayAddSB("配信OS", "osTypeNames", beforeInfo, afterInfo),
    createUserLogItemListByOption("ターゲティング情報", "targetingType", beforeInfo, afterInfo, options_zeus_ad_target),
    createUserLogItemListFromArrayAddSB("アフィニティカテゴリ", "affinityCategoryNames", beforeInfo, afterInfo),
    createUserLogItemListFromString("カスタムセグメント", "customSegmentName", beforeInfo, afterInfo),
    createUserLogItemListFromArrayAddSB("配信オーディエンス設定", "retargetingNames", beforeInfo, afterInfo),
    createUserLogItemListFromNumber("プレースメント", "placementSettingId", beforeInfo, afterInfo),
  ];
  const retObj = createLogDate(
    apolloContex,
    menu,
    category,
    actionType,
    displayName,
    items,
    campaignId,
    campaignName,
    adGroupId,
    adGroupName,

  );

  return retObj
}

export default AdGroupCreateZeus;
